<template>
  <div>
    <div class="bg-white rounded  my-4 shadow-md px-4 md:px-6 py-2 overflow-hidden mt-3">
      <h2 class="text-gray-800 text-lg font-bold text-center uppercase">Sámův kmenový svaz</h2>
      <div>
        <p>
          Slované byli <strong>v 7. století</strong> napadeni diokými kočovnými <strong>Avary</strong> z Asie, kteří sídlili na území dnešního Maďarska. V té době se na slovanských územích usadil,
          původně kvůli obchodu, <strong>kupec Sámo z Franské říše</strong> (oblast dnešní Francie a Německa). Slované se pod Sámovým vedením dokázali vymanit z mocenského područí
          <strong>Avarů</strong> a odolávali jejich nájezdům.
        </p>
        <p>
          Po vítězství nad Avary se <strong>Sámo</strong> stal <strong>vládcem slovanských kmenů</strong>
          (kolem roku 623 n. l.). Vznikl tak první mocenský útvar na našem území, který se nazývá
          <strong>Sámův kmenový svaz</strong>.
        </p>
        <p>Pod Sámovýn vedením odrazili Slované útok vojsk <strong>franského krále Dagoberta I.</strong>.</p>
        <p>Po Sámově smrti (v roce 658 nebo 659) se jeho svaz <strong>rozpadá</strong>.</p>
        <p>
          Podle některých historických zpráv měl Sámo údajně dvanáct manželek, se kterými měl celkem 37 dětí (22 synů a 15 dcer).
        </p>
        <p>O Sámovi a jeho sjednocení slovanských kmenů se dozvídáme z <strong>písemných záznamů</strong>. Popisuje je takzvaná Fredegarova kronika sepsaná na území dnešní Francie.</p>
        <p>O vývoji českých zemí v následujících asi 150 letech se nedochovaly žádné písemné zprávy. Další písemné památky hovoří o našem území až v době <strong>Velkomoravské říše</strong>.</p>
        <div class="p-2">
          <h2 class="text-gray-800 text-base font-bold text-center uppercase">
            Přehled: Keltové, Germáni, první Slované a Sámova říše v časovém sledu
          </h2>
          <img class="mx-auto" src="../assets/osa.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Samo"
};
</script>

<style lang="scss" scoped></style>
